import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";


var query = gql`
  query AssetReservations($organizationId: UUID!, $assetId: UUID!) {
    assetReservations(organizationId: $organizationId, assetId: $assetId) {
      id
      active
      application_id
      application_id_friendly
      asset_id
      organization_id
      published
      start_date
      type_id
      type
      end_date
      type_id
      
      confirmed
    }
  }
`;



export function apiGetAssetReservation(organizationId, assetId) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");

        client
            .query({
                query: query,
                variables: {organizationId, assetId},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.assetReservations);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to get asset reservations");
                reject(err); // R
            })
    });
}
